import { UnreadMessageCount } from "../../../api/chat";

export function unreadMessageCountToObject(counts: UnreadMessageCount[]) {
  return counts.reduce<Record<string, number>>((acc, { chatroom_id, count }) => {
    acc[chatroom_id] = count;
    return acc;
  }, {});
}